import { SidebarHeaderTitle } from './atoms';
import { EditTraversalCommands } from 'viewpointBuilder/traversals/editTraversalCommands';
import { SidebarMenu } from '@ardoq/sidebar-menu';
import { FlexBox, Stack } from '@ardoq/layout';
import { TertiaryButton } from '@ardoq/button';
import { ViewpointBuilderSidebarEmptyState } from 'viewpointBuilder/ViewpointBuilderSidebarEmptyState';
import type { JSX } from 'react';
import { EmptyStateToAddIllustration } from '@ardoq/status-ui';
import { t, type I18nLocale } from '@ardoq/i18n';

type PanelForWildcardTraversalProps = {
  commands: EditTraversalCommands;
  i18nLocale: I18nLocale;
};

export const WildcardTraversalPanel = ({
  commands,
  i18nLocale,
}: PanelForWildcardTraversalProps): JSX.Element => (
  <SidebarMenu
    isPageBodyMenu
    isResizable
    isRightContent
    isFullWidth={false}
    headerBody={
      <FlexBox gap="medium" padding="medium" width="full">
        <SidebarHeaderTitle>
          {t(
            i18nLocale,
            'viewpointBuilder:wildcardPanel.header',
            'Select references'
          )}
        </SidebarHeaderTitle>
      </FlexBox>
    }
  >
    <FlexBox
      height="full"
      width="full"
      gap="medium"
      backgroundColor="surfaceDefault"
      justify="center"
    >
      <FlexBox padding="medium">
        <Stack gap="medium" align="center">
          <ViewpointBuilderSidebarEmptyState
            title={t(
              i18nLocale,
              'viewpointBuilder:wildcardPanel.title',
              'Component overview'
            )}
            description={t(
              i18nLocale,
              'viewpointBuilder:wildcardPanel.description',
              "Overview Viewpoints select and show all direct references. These Viewpoints can't be edited but you can change the references shown in your view"
            )}
            media={<EmptyStateToAddIllustration />}
          >
            <TertiaryButton onClick={commands.expandDefaultTraversalRequested}>
              {t(
                i18nLocale,
                'viewpointBuilder:wildcardPanel.changeReferences',
                'Change selected references'
              )}
            </TertiaryButton>
          </ViewpointBuilderSidebarEmptyState>
        </Stack>
      </FlexBox>
    </FlexBox>
  </SidebarMenu>
);
